import R14, { } from "../core";
import DateUtils from "../utils/DateUtils";
import CommonUtility from "../utils/CommonUtility";

export default class SimpleMessageDomain extends R14.Domain {
  constructor(props) {
    super(props);
    this.state = {
      simpleMessage: [],
      searchSimpleMessage: [],
      currentThreadId: ""
    };
  }

  // display simple message list
  async displaySimpleMessage() {
    await this.getSimpleMessages();
    const { isSearchOpen, textInSearchBox, currentOpenScreen } = this.dm.userSearchDomain.state;
    if (isSearchOpen) this.dm.userSearchDomain.keyTypeSearch(textInSearchBox, currentOpenScreen);
  }

  // call DB & API  sync to simple message list
  async getSimpleMessages(
    filter,
    fields = "uid threadId payerId originator billerId billerName billerUid subject lastMessage lastMessageDate currentMsgCount readMsgCount",
  ) {
    let options = {
      sort: [{ field: "lastMessageDate", order: "DESC" }],
    };
    if(!!filter && filter.page) {
      options.page = filter.page;
      options.resultsPerPage = filter.resultsPerPage;
    }
    if(!!filter && filter.sort) options.sort = filter.sort;
    if(!!filter && filter.search) options.search = filter.search;
    try {
      let res = await this.dm.queryDomain.middleware(await this.api.qry(
        `query GetSimpleMessages($search: String, $addUpdate: Boolean, $source: String, $payload: String, $page: Int, $resultsPerPage: Int, $sort: [SortOption!] ){
          getSimpleMessages(search: $search, addUpdate: $addUpdate, source: $source, payload: $payload, page: $page, resultsPerPage: $resultsPerPage, sort: $sort){
        totalCount @include(if: true)
        nodes {
          ${fields}
        }
      }
    }`,
        options
      ));
      let results = res.data.getSimpleMessages.nodes;
      let list = await this.dm.rest.getBillers();
      for (let i = 0; i < results.length; i++) {
        let biller = list.find(x => x.uid === results[i].billerUid);
        results[i].biller = biller;
      }
      this.setState({ simpleMessage: results, searchSimpleMessage: results });
      return {
        nodes: results,
        totalCount: res.data.getSimpleMessages.totalCount
      }
    } catch (error) {
      return error;
    }
  }

  // get simple message details
  async getSimpleMessageByThreadId(threadId, profile, isValidPAM = false, totalCount) {
    try {
      const options = { threadId, profile, isValidPAM, totalCount }
      let res = await this.dm.queryDomain.middleware(this.api.qry(
        `query GetMessage($threadId: String!) {
          getSimpleMessage(threadId: $threadId) {
            success message error data
          }
        }`,
        options
      ));
      let messages = res.data.getSimpleMessage;
      if (messages && messages.data) messages = JSON.parse(messages.data);
      else messages = null
      if (!!messages) {
        messages = messages.sort((a, b) =>
          new Date(a.envelope.messageHeader.messageDateTime) - new Date(b.envelope.messageHeader.messageDateTime)
        )
      }
      return messages;
    } catch (error) {
      console.log("Messages  ::: ", error);
    }
  }

  // post new/ reply message
  async postSimpleMessage(payload) {
    await CommonUtility.htmlDecode(payload);
    try {
      const data = JSON.stringify(payload);
      let res = await this.api.mutate(
        `
      mutation CreateMessageBiller($input: CreateMessageBillerInput!) {
        createMessageBiller(input: $input){
          success message error data
        }
      }`,
        { input: { data } }
      );
      return res.data.createMessageBiller && res.data.createMessageBiller.data ? JSON.parse(res.data.createMessageBiller.data) : {};
    } catch (err) {
      console.log("Simple Message :::: ", err);
    }
  }

  //reply payload
  async replySimpleMessage(payload) {
    const { messageHeader, threadHeader } = payload.envelope;
    let newDatetime = DateUtils.isoFormateDate();
    const pids = await this.dm.rest.getLinkedPID();
    let linkedPids = pids.split(',');

    let senderName = await this.dm.billDetails.getSenderName({
      buId: messageHeader.buId,
      payerRef: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.recipientPIDRef : messageHeader.senderPIDRef,
      billerRef: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.senderPIDRef : messageHeader.recipientPIDRef,
      payerId: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.recipientPid : messageHeader.senderPid

    });
    let newPayload = {
      envelope: {
        ...payload.envelope,
        messageHeader: {
          ...messageHeader,
          messageId: CommonUtility.generate20Character(),
          messageDateTime: newDatetime,
          senderName: senderName,
          senderPid: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.recipientPid : messageHeader.senderPid,
          recipientPid: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.senderPid : messageHeader.recipientPid,
          senderPIDRef: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.recipientPIDRef : messageHeader.senderPIDRef,
          recipientPIDRef: linkedPids.find(x => x.toLowerCase() === threadHeader.respondentPid.toLowerCase()) ? messageHeader.senderPIDRef : messageHeader.recipientPIDRef,
        }
      },
      messageMeta: payload.messageMeta,
      attachments: payload.attachments
    };
    return newPayload;
  }

  // new message payload
  async getMessagePayload(data) {
    const { subject, messageBody, attachments } = data;
    let datetime = DateUtils.isoFormateDate();
    let senderName = await this.dm.billDetails.getSenderName({
      // buId: data.buId,
      // billerRef: data.billerRef,
      // payerRef: data.payerRef,
      payerId: data.payerId
    });

    let uniqueId = CommonUtility.generate20Character();
    return {
      envelope: {
        threadHeader: {
          subject,
          profile: "simpleMessage",
          threadId: `${data.payerId}-${data.billerId}-${uniqueId}`,
          originatorPid: data.payerId,
          respondentPid: data.billerId,
          threadDateTime: datetime,
          threadPriority: "high",
          //   accountNumber: "0",
          //   isExternalCustomer: false,
        },
        messageHeader: {
          senderName: senderName,
          senderPid: data.payerId,
          recipientPid: data.billerId,
          //   buId: data.buId,
          //   senderPIDRef: data.payerRef,
          //   recipientPIDRef: data.billerRef,
          messageId: uniqueId,
          messageDateTime: datetime,
        },
        messageBody: { messageBody },
      },
      attachments,
      messageMeta: {
        numMessages: 1,
        signature: "",
        deliveryPath: {
          fromID: datetime,
          timestamp: datetime,
          toID: datetime,
          senderCert: "",
        },
      },
    };
  }

 async compiledMessagesNotification(threads) {
    if (!!threads && threads.length > 0) {
      await this.getSimpleMessages();
    }
  }

  // other module method
  async getLinkPIDSuggestions() {
    const profile = await this.dm.rest.getUser();
    const access_token = await this.dm.userSession.getAccessToken();

    let options = {
      email: profile.email,
      access_token,
    };
    try {
      let res = await this.dm.queryDomain.middleware(this.api.qry(
        `query GetLinkPIDSuggestions($email: String!, $access_token: String!){
          getLinkPIDSuggestions(email: $email, access_token: $access_token ) 
        }`,
        options
      ));

      if (!!res.data.getLinkPIDSuggestions) return JSON.parse(res.data.getLinkPIDSuggestions);
      return res.data.getLinkPIDSuggestions;
    } catch (error) {
      return error;
    }
  }

  async postLinkPayerPID(payerPID = [], primaryPID) {
    const profile = await this.dm.rest.getUser();
    const access_token = await this.dm.userSession.getAccessToken();
    const payerPIDList = payerPID.map(pid => {
      return { buid: pid.buId, billerPID: pid.billerPID, payerPID: pid.payerPID }
    });
    let input = {
      emailID: primaryPID.email,
      mobileNumber: profile.mobileNumber,
      payerPIDList: payerPIDList
    };
    try {
      let res = await this.dm.queryDomain.middleware(this.api.mutate(
        `mutation LinkPayerPID($input: LinkPayerInput!, $access_token: String!)  {
            linkPayerPID(input: $input, access_token: $access_token)
         }`,
        { input, access_token }
      ));

      return res.data.linkPayerPID;
    } catch (error) {
      return error;
    }
  }

}
